import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MasiveCancelTripsComponent } from './masive-cancel-trips.component';
import {ReactiveFormsModule} from '@angular/forms';
import {Trip2ThemeModule} from '../../../trip2-theme/trip2-theme.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    Trip2ThemeModule
  ],
  exports: [
    MasiveCancelTripsComponent
  ],
  declarations: [
    MasiveCancelTripsComponent
  ]
})
export class MasiveCancelTripsModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/masive-cancel-trips/masive-cancel-trips.module.ts